import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/C7t8t0wM4WlmSTu5ppij/locations/${locationId}`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="240px" alt="About" />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/C7t8t0wM4WlmSTu5ppij/locations/${locationId}`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="240px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
